import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";

import {WmsItemsStatus} from "utils/WmsItemsStatus";

StatusBadge.propTypes = {
    status: PropTypes.string
};

function StatusBadge({status = null}) {
    if (!status) {
        return null;
    }

    function getStatusColor(status) {
        switch (status) {
            case WmsItemsStatus.READY_TO_BE_PACKED:
                return 'oceanBlue';
            case WmsItemsStatus.CANCELED:
                return 'error';
            default:
                return 'darker';
        }
    }

    return (
        <Badge size={'large'} color={getStatusColor(status)}>
            <FormattedMessage id={`wms.product.status.${status}`} />
        </Badge>
    );
}

export default StatusBadge;
